<script>
import {api_baseURL} from "@/utils/init.js";
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
export default {
  name: 'ExtraPages',
  props: {
    uploadedFiles: {
      type: Array,
	  default:[],
      required: true
    },
    position: {
      type: String,
      required: true
    },
    pageGap: {
      type: Boolean,
      default: true
    },
    startPage: {
      type: Number,
      default: undefined
    },
    colorScheme: {
      type: Object,
      default: () => ({ header: '#545454', footer: '#545454' })
    },
    orientation: {
      type: String,
      default: 'portrait'
    },
	fileId: {
      type: String,
      required: true
	}
  },
  data() {
    return {
	 renderedPdfImage:null,
	};
  },
  async mounted() {
      this.m_loadCanvasImg();
},
  computed: {
    isLandscape() {
      return this.orientation === 'landscape';
    },
    isPortrait() {
      return this.orientation === 'portrait';
    },
	pdfFile(){
		return this.uploadedFiles.filter((file) => file.id === this.fileId)[0];
	},
    pdfPages() {
      const pages = [];
      const filesForPosition = this.uploadedFiles.filter((file) => file.position === this.position);
      
      filesForPosition.forEach(file => {
        if (file.isPDF && file.preview && Array.isArray(file.preview)) {
          file.preview.forEach((pageImage, index) => {
            pages.push({
              fileId: file.id,
              bannerTitle: file.bannerTitle,
              headerColor: file.bannerHeaderColor,
              footerColor: file.bannerFooterColor,
              pageImage,
              pageIndexInFile: index
            });
          });
        }
      });
      return pages;
    },
	c_pdfURL() {
        let filePath="";
        if(this.pdfFile?.fileName) filePath=`${api_baseURL}proposalFile?fileName=${encodeURIComponent(this.pdfFile?.fileName)}`;
        return filePath;
	}
  },
  methods: {
  async m_loadCanvas(){
      if(!this.c_pdfURL) return;
      const pdf = await pdfjsLib.getDocument(this.c_pdfURL).promise;
      const page = await pdf.getPage(1);

      const viewport = page.getViewport({ scale: 1.5 });
      const canvas = this.$refs.pdfCanvas;
      const ctx = canvas.getContext("2d");

      canvas.height = viewport.height;
      canvas.width = viewport.width;

     await page.render({ canvasContext: ctx, viewport }).promise;
  },
async m_loadCanvasImg() {
  if (!this.c_pdfURL) return;

  // Reset image so Vue shows the canvas again
  this.renderedPdfImage = null;

  await this.$nextTick(); // ensures canvas is back in DOM

  const canvas = this.$refs.pdfCanvas;
  const pdf = await pdfjsLib.getDocument(this.c_pdfURL).promise;
  const page = await pdf.getPage(1);

  const viewport = page.getViewport({ scale: 1.5 });
  const ctx = canvas.getContext("2d");

  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({ canvasContext: ctx, viewport }).promise;

  // Convert to image
  this.renderedPdfImage = canvas.toDataURL("image/png");
}
},
  watch:{
	fileId:{
	     handler(nv) {
				this.m_loadCanvasImg();
			}
	
	}
  }
};
</script>

<template>
  <div class="d-flex flex-column w-100 extra-pages-ignore" :class="{ 'page-gap': pageGap }">
    <div v-if="pdfFile" class="uploaded-file-preview">
      <div class="pdf-preview-container" :class="{ 'page-gap': pageGap }">
        <div :id="fileId" class="pdf-page"  :class="{ 'landscape': isLandscape, 'portrait': isPortrait }">
          <div class="banner header-banner" :style="{ background: pdfFile.headerColor || (colorScheme && colorScheme.header) }">
            <h2>{{ pdfFile.bannerTitle }}</h2>
          </div>
          <div class="page-image-container">
            <!--img :src="c_pdfURL" class="page-image" /-->
			<!--embed :src="c_pdfURL" type="application/pdf" width="100%" height="100%" /-->
             <div class="pdf-wrapper">
              <canvas v-if="!renderedPdfImage" ref="pdfCanvas"></canvas>
              <img v-else  :src="renderedPdfImage" class="pdf-image"></img> 
             </div>
          </div>
          <div class="banner footer-banner" :style="{ background: pdfFile.footerColor || (colorScheme && colorScheme.footer) }">
            <span v-if="startPage !== undefined" class="page-number">{{ String(startPage).padStart(2, '0')
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.page-gap {
  gap: 20px;
}

.insert-section {
  display: flex;
  align-items: center;
  justify-content: center;

  .btn-insert {
    background-color: #f8f9fa;
    border: 1px dashed #4475b4;
    color: #4475b4;
    padding: 6px 12px;
    width: 211mm;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
      background-color: #4475b4;
      color: white;
      border-style: solid;
    }
  }
}

.uploaded-file-preview {
  position: relative;
  margin: auto;

  .pdf-preview-container {
    display: flex;
    flex-direction: column;

    .pdf-page {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      background-color: white;
      overflow: hidden;
      gap: 5px;

      &.landscape {
        width: 296.83mm;
        height: 211mm;
      }

      &.portrait {
        width: 211mm;
        height: 296.83mm;
      }

      .banner {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #545454;
        width: 100%;
        height: 15.875mm;
        flex-shrink: 0;
        position: relative;

        h2 {
          font-size: 18px;
          color: white;
          margin-bottom: 0px;
          font-weight: 700;
          font-family: Helvetica;
        }

        .page-number {
          position: absolute;
          right: 16px;
          bottom: 10px;
          font-size: 14px;
          font-weight: 700;
          color: white;
          font-family: Helvetica;
        }
      }

      .page-image-container {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        width: 100%;
        overflow: hidden;

        .page-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
